// extracted by mini-css-extract-plugin
export default {"container":"ScrollArrow_container__Xrjv1","icon":"ScrollArrow_icon__MPjgA","animate":"ScrollArrow_animate__neScc","bounce":"ScrollArrow_bounce__2p5Uu"};